import maNavbarCategory from '@/components/navbarCategories'
import {
    mapState,
    mapMutations,
    mapActions
} from 'vuex'
import { apiSearchMobilier, apiSearchPredictibles } from '@/modules/Damage/services/menus'
import debounce from '@/utils/debounce'
import {
    WARRANTY_MODULE_NAME,
    WARRANTY_GET_FORMS,
    WARRANTY_CLEAR_REPORT,
    WARRANTY_UPDATE_REPORT,
    WARRANTY_UPDATE_CATEGORIES_QTY,
    WARRANTY_UPDATE_CATEGORIES_MOBILIER,
    WARRANTY_CLEAR_FORMS,
    WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES,
    WARRANTY_UPDATE_LITERALS_MOBILIER,
    WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
    WARRANTY_CLEAR_MOBILIER_PROPERTIES,
    WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
    WARRANTY_UPDATE_DAMAGED_ITEM,
    WARRANTY_UPDATE_DAMAGED_ITEM_KEY,
    WARRANTY_UPDATE_DAMAGED_PART_KEY
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

export default {
    name: 'damageMobilier',

    mixins: [flowMixin],

    components: {
        maNavbarCategory
    },

    data: function() {
        return {
            listCategories: [],
            listNestedTitles: [],
            inputTxtValue: '',
            searchIsActive: false,
            listCat: [],
            levels: {},
            searchNotFound: false,
            listPredictibles: [],
            isPredictible: false,
            lastCat3: false,
            lastCat2: false
        }
    },

    computed: {
        ...mapState(WARRANTY_MODULE_NAME, {
            stateWarrantyReport: 'report',
            stateWarrantyForms: 'forms',
            stateWarrantyTextInputSearchMobilier: 'textInputSearchMobilier',
            stateWarrantyKeysMobilier: 'keysMobilier',
            stateWarrantyCategoriesMobilier: 'categoriesMobilier',
            stateWarrantyCategoryFinalLevel: 'categoryFinalLevel',
            stateWarrantyDamagedItemKey: 'damagedItemKey',
            stateWarrantyDamagedPartKey: 'damagedPartKey',
            stateWarrantyDamageTypeLiteral: 'damageTypeLiteral',
            stateWarrantyLastSelectedKey: 'lastSelectedKey'
        })
    },

    methods: {
        ...mapMutations(WARRANTY_MODULE_NAME, {
            'mutWarrantyClearReport': WARRANTY_CLEAR_REPORT,
            'mutWarrantyClearForms': WARRANTY_CLEAR_FORMS,
            'mutWarrantyUpdateReport': WARRANTY_UPDATE_REPORT,
            'mutWarrantyUpdateCategoriesQty': WARRANTY_UPDATE_CATEGORIES_QTY,
            'mutWarrantyUpdateCategoriesMobilier': WARRANTY_UPDATE_CATEGORIES_MOBILIER,
            'mutWarrantyUpdateLastSelectedProperties': WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES,
            'mutWarrantyUpdateLiteralsMobilier': WARRANTY_UPDATE_LITERALS_MOBILIER,
            'mutWarrantyUpdateCategFinalLevel': WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
            'mutWarrantyClearMobilierProperties': WARRANTY_CLEAR_MOBILIER_PROPERTIES,
            'mutWarrantyUpdateTextSearchMobilier': WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
            'mutWarrantyUpdateDamagedItem': WARRANTY_UPDATE_DAMAGED_ITEM,
            'mutWarrantyUpdateDamagedItemKey': WARRANTY_UPDATE_DAMAGED_ITEM_KEY,
            'mutWarrantyUpdateDamagedPartKey': WARRANTY_UPDATE_DAMAGED_PART_KEY

        }),
        ...mapActions(WARRANTY_MODULE_NAME, {
            'actWarrantyGetForms': WARRANTY_GET_FORMS
        }),

        handleClickPrevPage() {
            const damagesTypesViewName = 'damages-types'
            const propertyType = this.getPropertyType
            this.goToView(damagesTypesViewName, { propertyType })
        },

        /**
         * When a category of the first level list of a category is clicked it updates the damaged key, the last selected properties, the categories mobilier object, the literals and checks if this category is final level category or not, and goes to next route
         */
        handleClickCategory(key, value, id, literal) {
            this.mutWarrantyUpdateDamagedItemKey(key)
            let category = 'cat1'
            this.mutWarrantyUpdateLastSelectedProperties({ key, category })
            let reportObj = Object.assign(this.stateWarrantyReport[0], {})
            reportObj[key] = value
            this.mutWarrantyUpdateCategoriesMobilier(reportObj)
            this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
            this.mutWarrantyUpdateDamagedPartKey(literal)
            this.mutWarrantyUpdateCategoriesQty(1)
            this.mutWarrantyClearForms()
            this.checkIfUptecFeature()
        },

        /**
         * Checks if the form item is uptec
         */
        checkIfUptecFeature() {
            let idFeatureUptec = null
            this.mutWarrantyClearForms()
            const report = this.stateWarrantyCategoriesMobilier
            const warrantyId = this.getWarrantyId
            this.actWarrantyGetForms({ report, warrantyId }).then((res) => {
                if (res.formsUpdated) {
                    // check level
                    this.stateWarrantyForms[0].form.regions[0].inputs.forEach(input => {
                        if (input.name === this.stateWarrantyDamagedItemKey) {
                            input.options.forEach(option => {
                                if (option.literal === this.stateWarrantyDamagedPartKey && option.is_upptec_damage && option.upptec_damage_type === 'FEATURE') {
                                    idFeatureUptec = option.upptec_product_group_id
                                }
                            })
                        }
                    })
                    if (idFeatureUptec) {
                        this.goToSearchMobilierUptec(idFeatureUptec)
                    } else {
                        this.goToNextRoute()
                    }
                }
            })
        },

        /**
         * ProductIdGroup product id group of the uptec item that will be used for the search of it and adding the damage
         */
        goToSearchMobilierUptec(productIdGroup) {

            const damageMobilierUptecFeatureViewName = 'damageMobilierUptecFeature'
            const propertyType = this.getPropertyType
            const damageType = this.getDamageType
            const productId = productIdGroup
            this.goToView(damageMobilierUptecFeatureViewName, { propertyType, damageType, productId })
        },

        goToNextRoute() {
            const propertyType = this.getPropertyType
            const damageType = this.getDamageType
            if (this.lastCat3 == true) {
                const damageMobilierCategory3ViewName = 'damageMobilierCategory3'
                this.goToView(damageMobilierCategory3ViewName, { propertyType, damageType })
            } else if (this.lastCat2 == true) {
                const damageMobilierCategory2ViewName = 'damageMobilierCategory2'
                this.goToView(damageMobilierCategory2ViewName, { propertyType, damageType })
            } else {
                const damageMobilierCategory1ViewName = 'damageMobilierCategory1'
                this.goToView(damageMobilierCategory1ViewName, { propertyType, damageType })
            }
        },

        handleChangeInputTxt: debounce(function() {
            this.searchNotFound = false
            if (this.inputTxtValue.length >= 2) {
                this.listNestedTitles = []
                this.searchIsActive = true
                const searchText = this.inputTxtValue
                const searchParams = {
                    'literal': searchText
                }
                const warrantyId = this.getWarrantyId
                apiSearchMobilier(warrantyId, searchParams).then((result) => {
                    if (result.length > 0) {
                        this.addNestedTitles(result)
                        this.$nextTick(() => {
                            this.highlightSearch()
                        })
                    } else {
                        this.searchNotFound = true
                    }
                })
            } else {
                this.searchIsActive = false
            }
        }, 250),

        /**
         * Adds the nexted titles for the category clicked
         */
        addNestedTitles(list) {
            this.listNestedTitles = []
            list.forEach(firstCategory => {
                this.listNestedTitles.push({
                    cat1: {
                        'literal': firstCategory.literal,
                        'name1': firstCategory.component_name,
                        'value1': firstCategory.component_value,
                        'children': firstCategory.children.length
                    }
                })
                if (firstCategory.children.length > 0) {
                    firstCategory.children.forEach(secondCategory => {
                        this.listNestedTitles.forEach(title => {
                            if (title.cat1.literal === firstCategory.literal) {
                                if (!title.cat1.cat2) title.cat1['cat2'] = []
                                if (firstCategory.children.length !== title.cat1.cat2.length) {
                                    title.cat1.cat2.push({
                                        'literal': secondCategory.literal,
                                        'name1': firstCategory.component_name,
                                        'value1': firstCategory.component_value,
                                        'name2': secondCategory.component_name,
                                        'value2': secondCategory.component_value,
                                        'children': secondCategory.children.length
                                    })
                                }
                            }
                        })
                        if (secondCategory.children.length > 0) {
                            secondCategory.children.forEach(thirdCategory => {
                                this.listNestedTitles.forEach(title => {
                                    title.cat1.cat2.forEach(cat => {
                                        if (cat.literal === secondCategory.literal && title.cat1.cat2.length && title.cat1.literal === firstCategory.literal) {
                                            if (!cat.cat3) cat['cat3'] = []
                                            if (secondCategory.children.length !== cat.cat3.length) {
                                                cat.cat3.push({
                                                    'literal': thirdCategory.literal,
                                                    'name1': firstCategory.component_name,
                                                    'value1': firstCategory.component_value,
                                                    'name2': secondCategory.component_name,
                                                    'value2': secondCategory.component_value,
                                                    'name3': thirdCategory.component_name,
                                                    'value3': thirdCategory.component_value,
                                                    'children': thirdCategory.children.length
                                                })
                                            }
                                        }
                                    })
                                })
                            })
                        }
                    })
                }
            })
        },

        /**
         * Adds the report proerties to get the form
         */
        addReportProperties() {
            let key = 'propertyType'
            let value = this.getPropertyType
            this.mutWarrantyUpdateReport({ key, value })
            key = 'ASSETS'
            value = this.getDamageType
            this.mutWarrantyUpdateReport({ key, value })
        },

        /**
         * Gets the form data to print the categories
         */
        getForm() {
            this.mutWarrantyClearForms()
            this.mutWarrantyClearReport()
            this.addReportProperties()
            const warrantyId = this.getWarrantyId
            const report = this.stateWarrantyReport
            this.actWarrantyGetForms({ report, warrantyId }).then((resp) => {
                if (resp.formsUpdated) {
                    const forms = this.stateWarrantyForms[0].form.regions[0].inputs
                    this.filterForm(forms)
                }
            })
        },

        /**
         * Removes the input that was selected previouslyfrom the from, using the last selectedKey and the hidden input and sets the list categories with the first input
         */
        filterForm(formsData) {
            let filtertedForm = formsData
            filtertedForm = filtertedForm.filter(input => {
                return input.name !== this.stateWarrantyLastSelectedKey
            })

            filtertedForm = filtertedForm.filter(input => {
                return input.type !== 'hidden'
            })
            this.listCategories = filtertedForm[0]
        },

        /**
         * When the search is active, it will update the literals of the clicked item
         */
        handleClickCategExtraDetails(children, literal1, literal2, literal3) {
            let category
            let literal
            this.mutWarrantyUpdateCategoriesQty(children)
            if (children === 0) {
                this.mutWarrantyUpdateCategFinalLevel(true)
            }
            if (literal1 && literal2 && literal3) {
                category = 'cat1'
                literal = literal1
                this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
                category = 'cat2'
                literal = literal2
                this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
                category = 'cat3'
                literal = literal3
                this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
                this.mutWarrantyUpdateDamagedPartKey(literal3)
            } else if (literal1 && literal2) {
                category = 'cat1'
                literal = literal1
                this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
                category = 'cat2'
                literal = literal2
                this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
                this.mutWarrantyUpdateDamagedPartKey(literal2)
            } else if (literal1) {
                category = 'cat1'
                literal = literal1
                this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
                this.mutWarrantyUpdateDamagedPartKey(literal1)
            }
        },

        /**
         * When the search is active and a category of the searched items is clicked it will update the categoires mobilier object and goes to next route
         */
        handleClickCategorySearch(name1, value1, name2, value2, name3, value3) {
            let reportObj = {}
            reportObj['propertyType'] = this.getPropertyType
            reportObj['ASSETS'] = this.getDamageType
            if (name1 && name2 && name3) {
                reportObj[name1] = value1
                reportObj[name2] = value2
                reportObj[name3] = value3
                this.mutWarrantyUpdateDamagedItemKey(name3)
                this.mutWarrantyUpdateCategFinalLevel(true)
                this.lastCat3 = true;
            } else if (name1 && name2) {
                reportObj[name1] = value1
                reportObj[name2] = value2
                this.lastCat2 = true;
                this.mutWarrantyUpdateDamagedItemKey(name2)
            } else if (name1) {
                reportObj[name1] = value1
                this.mutWarrantyUpdateDamagedItemKey(name1)
            }
            this.mutWarrantyUpdateCategoriesMobilier(reportObj)
            this.checkIfUptecFeature()
        },

        /**
         * Highlight the search input text in the text result
         */
        highlightSearch() {
            var text = document.getElementById('search_text').value
            var searchResults = document.querySelectorAll('.searchText')
            searchResults.forEach(result => {
                result.innerHTML = result.innerHTML.replace(new RegExp('(' + text + ')', 'ig'), '<span class=highlight>$1</span>')
            })
        },
        getPredictibles() {
            const warrantyId = this.getWarrantyId
            apiSearchPredictibles(warrantyId).then((res) => {
                this.listPredictibles = res
            })
        },
        handleClickPredictibles(components) {
            this.isPredictible = true
            let reportObj = Object.assign(this.stateWarrantyReport[0], {})
            components.forEach(component => {
                this.mutWarrantyUpdateDamagedPartKey(component.literal)
                reportObj[component.component_name] = component.component_value
                let category = `cat${component.level}`
                let literal = component.literal
                this.mutWarrantyUpdateDamagedItemKey(component.component_name)
                this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
            })
            this.mutWarrantyUpdateCategoriesMobilier(reportObj)
            this.mutWarrantyUpdateCategoriesQty(0)
            this.mutWarrantyUpdateCategFinalLevel(true)
            this.checkIfUptecFeature()
        }
    },

    /**
     * Clears the mobilier properties; if there is text input search mobilier it will update the input text value and execute the handler that searches; executes get form
     */
    mounted() {
        this.getPredictibles()
        this.mutWarrantyClearMobilierProperties()
        if (this.stateWarrantyTextInputSearchMobilier) {
            this.inputTxtValue = this.stateWarrantyTextInputSearchMobilier
            this.handleChangeInputTxt()
        }
        this.getForm()
    },

    /**
     * Clears the input text value and the state search mobilier input text
     */
    beforeDestroy: function() {
        this.inputTxtValue = ''
        this.mutWarrantyUpdateTextSearchMobilier('')
    }
}